module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new":"New!","selfRefused":"Refused"}}')
  delete Component.options._Ctor
}
